import React from 'react';
import { Box } from '@mui/material';

const SmallPhotoUploaderLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={theme => ({
        width: '30%',
        minWidth: '100px',
        '& #photosIds': {
          padding: '5px',
        },
        [theme.breakpoints.down('smallMobile')]: {
          minWidth: '50px',
        },
        '& .upload-help-text': {
          display: 'none',
        },
        '& .upload-block': {
          height: '100%',
          '&:has(.photo-preview) > .photo-upload': {
            display: 'none',
          },
          '& > .photo-upload': {
            width: '100%',
            height: '25px',
            backgroundColor: 'primary.main',
            borderRadius: '3px',
            '& span': {
              color: 'common.white',
              marginTop: 0,
              fontWeight: 500,
            },
          },
        },
        '&>div': {
          marginBottom: 0,
          height: '100%',
        },
        '& .photo-preview': {
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      })}
    >
      {children}
    </Box>
  );
};

export default SmallPhotoUploaderLayout;
